<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" @click="cancel">{{ t("Cancel") }}</ion-button>
      </ion-buttons>
      <ion-title>{{ t("Add Repertoire") }}</ion-title>
      <ion-buttons slot="end">
        <ion-button :disabled="repertoireName.length == 0" @click="confirm" :strong="true">
                {{ t("Done") }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding" color="light">
    <ion-item>
      <span class="labelWidth">{{ t("Repertoire Name") }}</span>
      <ion-input label-placement="fixed" 
                  :placeholder="placeHolderString" :value="repertoireName"
                  @ionInput="nameChange">
      </ion-input>
    </ion-item>
    <ion-item>
    <ion-radio-group value="white" @ionChange="colorChange($event)">
      
      <ion-radio value="white" aria-label="White" label-placement="start">
        {{ t("Color") }}:  {{ t("White") }}
      </ion-radio>
      <ion-radio value="black" aria-label="Black" label-placement="start">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ t("Black") }}
      </ion-radio>
    </ion-radio-group>
  </ion-item>
  </ion-content>
</template>

<script  setup>
  import {
    IonRadio,
    IonRadioGroup,
    IonRange,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    IonItem,
    IonInput,
    IonLabel,
    modalController,
  } from '@ionic/vue';
  import { defineComponent, ref } from 'vue';
  import { t , replaceMultipleAll } from '@/composables/translateText.js'

  const props = defineProps({
    name : String,
    color : String
	})

  const name = ref();

  const repertoireName = ref("")
  const color = ref("white")
  const placeHolderString = ref(t("Enter name"))

  const cancel = () => modalController.dismiss(null, 'cancel');

  function confirm() {
    var result = { 
                 name : repertoireName.value,
                 color : color.value,
    }

    //console.log("CONFIRM",result)
    modalController.dismiss(result, 'confirm');
  }

  function nameChange(ev) {
    //console.log("name ",ev)
    const value = ev.target.value;
    //console.log("repertoire name ",value)
    repertoireName.value = value.trim()
  }

  function colorChange(ev) {
    //console.log("color Change",ev.detail)
    //console.log('Current value:', JSON.stringify(ev.detail.value));
    color.value = ev.detail.value
  }

</script>

<style scoped>

ion-radio::part(container) {
    width: 30px;
    height: 30px;

    border-radius: 8px;
    border: 2px solid #ddd;
  }

  ion-radio::part(mark) {
    background: none;
    transition: none;
    transform: none;
    border-radius: 0;
  }

  ion-radio.radio-checked::part(container) {
    background: #6815ec;
    border-color: transparent;
  }

  ion-radio.radio-checked::part(mark) {
    width: 6px;
    height: 10px;

    border-width: 0px 2px 2px 0px;
    border-style: solid;
    border-color: #fff;

    transform: rotate(45deg);
  }

  .labelWidth {
    width: 250px;
  }

</style>
